<template>
    <div class="login-container other" ref="login" @keyup.enter.native="handleLogin">
        <loginHeader></loginHeader>
        <div class="other-form">
            <div class="other-form-title">
                <div class="t">欢迎注册成为机构成员</div>
                <div>已有账号 <span class="blue">快捷登录</span></div>
            </div>
            <el-form :model="ruleForm" :inline-message="true" :rules="rules" ref="ruleForm">
                <el-form-item prop="name">
                    <div class="forget-line">
                        <div class="input">
                            <el-input v-model="ruleForm.name" placeholder="设置用户名"></el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="name">
                    <div class="forget-line">
                        <div class="input">
                            <el-input v-model="ruleForm.name" placeholder="设置您的登录密码"></el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="name">
                    <div class="forget-line">
                        <div class="input">
                            <el-input v-model="ruleForm.name" placeholder="请再次输入您的密码"></el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="name">
                    <div class="forget-line">
                        <div class="input">
                            <el-input v-model="ruleForm.name" placeholder="请输入邮箱">
                            </el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="name">
                    <div class="forget-line">
                        <div class="input">
                            <el-input v-model="ruleForm.name" placeholder="请输入手机号">
                                <template slot="prepend">+86</template>
                            </el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="forget-line">
                        <div class="input">
                            <JcRange status="loginForm.status" :successFun="onMpanelSuccess" :errorFun="onMpanelError"></JcRange>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="name">
                    <div class="forget-line">
                        <div class="input">
                            <el-input v-model="ruleForm.name" placeholder="请输入手机短信验证码">
                                <template slot="prepend">验证码</template>
                            </el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="forget-line">
                        <div class="input">
                            <el-button type="primary" class="w100" @click="submitForm('ruleForm')">同意条款并注册</el-button>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="forget-line">
                        <div class="input">
                            <el-checkbox v-model="checked">《服务条款》</el-checkbox>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import loginHeader from './components/loginheader'
import { mapGetters } from "vuex";
import { dateFormat } from "@/util/date";
import { validatenull } from "@/util/validate";
import { getQueryString, getTopUrl } from "@/util/util";
import JcRange from "@/components/JcRange/index.vue";

export default {
    name: "login",
    components: {
        loginHeader,
        JcRange
    },
    data() {
        return {
            time: "",
            activeName: "user",
            socialForm: {
                tenantId: "000000",
                source: "",
                code: "",
                state: "",
            },
            ruleForm: {
                name: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                    { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ]
            },
            checked:true
        };
    },
    watch: {
        $route() {
            this.handleLogin();
        }
    },
    created() {
        this.handleLogin();
        this.getTime();
    },
    mounted() {},
    computed: {
        ...mapGetters(["website", "tagWel"])
    },
    props: [],
    methods: {
        getTime() {
            setInterval(() => {
                this.time = dateFormat(new Date());
            }, 1000);
        },
        handleLogin() {
            const topUrl = getTopUrl();
            const redirectUrl = "/oauth/redirect/";
            this.socialForm.source = getQueryString("source");
            this.socialForm.code = getQueryString("code");
            this.socialForm.state = getQueryString("state");
            if (validatenull(this.socialForm.source) && topUrl.includes(redirectUrl)) {
                let source = topUrl.split("?")[0];
                source = source.split(redirectUrl)[1];
                this.socialForm.source = source;
            }
            if (!validatenull(this.socialForm.source) && !validatenull(this.socialForm.code) && !validatenull(this.socialForm.state)) {
                const loading = this.$loading({
                    lock: true,
                    text: '第三方系统登录中,请稍后。。。',
                    spinner: "el-icon-loading"
                });
                this.$store.dispatch("LoginBySocial", this.socialForm).then(() => {
                    window.location.href = topUrl.split(redirectUrl)[0];
                    this.$router.push({ path: this.tagWel.value });
                    loading.close();
                }).catch(() => {
                    loading.close();
                });
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
};

</script>
<style lang="scss">
@import "@/styles/login.scss";

</style>
